import request from '../../src/state/modules/axios'

export function getLanguages(){
    return request({
        url: '/api/lesson-languages',
        method: 'get',
    })
}

export function getLanguageById(data){
    return request({
        url: `/api/lesson-languages/${data.id}`,
        method: 'get',
    })
}

export function addLanguages(data){
    return request({
        url: '/api/lesson-languages',
        method: 'post',
        data,
    })
}

export function editLanguage(data){
    return request({
        url: `/api/lesson-languages/${data.id}`,
        method: 'put',
        data,
    })
}


export function deleteLanguages(data){
    return request({
        url: `/api/lesson-languages/${data.id}`,
        method: 'delete'
    })
}